// @ts-check
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'core';

const InlineTooltip = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;

  .uds-tooltip-container {
    display: inline-block !important;
    vertical-align: middle;
  }

  button.uds-tooltip {
    display: inline-block !important;
    vertical-align: middle !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none;
    background: none;
  }

  .fa-stack {
    font-size: 0.7em;
  }
`;

/**
 * @param {{
 * totalRecords: number
 * unmatchedImportedFile: number
 * unmatchedFiltered: number
 * }} props
 */
const ExportFileSummary = ({
  totalRecords,
  unmatchedImportedFile,
  unmatchedFiltered,
}) => {
  return (
    <div data-testid="export-file-summary-container">
      <header>
        <h4>
          Export File Summary
          <InlineTooltip>
            <Tooltip tooltipId="export-file-summary-tooltip">
              Applicable if a file was imported for this campaign. These details
              show the cross-section of the student list with the uploaded file
              and the segmented list from Campaign Builder.
            </Tooltip>
          </InlineTooltip>
        </h4>
      </header>
      <div>
        <strong>Total Export File Records:</strong> {totalRecords || 'n/a'}
        <div>
          <strong>Not Included (File Only):</strong>{' '}
          {unmatchedImportedFile || 'n/a'}
        </div>
        <div>
          <strong>Not Included (CB Only):</strong> {unmatchedFiltered || 'n/a'}
        </div>
      </div>
    </div>
  );
};

export { ExportFileSummary };
